import { isDmExceptionsResponse, } from '@urbanik/api-contracts';
import { DmStagingApiError } from './dm-staging.js';
export async function getDmExceptions(base, input = {}, signal) {
    const url = new URL(`${base.replace(/\/$/, '')}/identity/financial-migration/dm-exceptions`);
    Object.entries(input).forEach(([key, value]) => {
        if (value !== undefined && value !== '')
            url.searchParams.set(key, String(value));
    });
    let response;
    try {
        response = await fetch(url, {
            credentials: 'include',
            headers: { Accept: 'application/json' },
            signal: signal ?? null,
        });
    }
    catch {
        throw new DmStagingApiError('unavailable', 'No pudimos consultar las excepciones DM.');
    }
    if (!response.ok)
        throw new DmStagingApiError(response.status === 401
            ? 'unauthorized'
            : response.status === 403
                ? 'forbidden'
                : response.status === 400
                    ? 'invalid'
                    : 'unavailable', 'No pudimos consultar las excepciones DM.');
    const body = await response.json().catch(() => null);
    if (!isDmExceptionsResponse(body))
        throw new DmStagingApiError('invalid', 'La respuesta de excepciones DM no es válida.');
    return body;
}
